// @ts-nocheck
import * as React from 'react';

import { 
    makeLayout, makeLayoutSlot, 
    makePlugin, makePluginSlot,
    makeController, effectGetter,
    makeEntry, IdentityComponent,
    IControllerContext, IEffectContext, IPluginContext, ISlotContext, 
} from '../../core/Slot';


export const URI = 'Tooltip';
export type URI = typeof URI;

declare module '../../core/Slot' {
    interface URItoKind {
        [URI]: {
            slots: {
                target: {
                    innerProps: {
                        innerRef: React.RefObject<HTMLDivElement>,
                    },
                    outerProps: React.HtmlHTMLAttributes<HTMLElement>,
                },
                text: {
                    outerProps: { children: React.ReactNode },
                    innerProps: {},
                },
            },
            controllers: {},
            effects: [],
            plugins: {},
        },
    }
}


const SlotContext = React.createContext({} as ISlotContext<URI>);
const ControllerContext = React.createContext({} as IControllerContext<URI>);
const EffectContext = React.createContext({} as IEffectContext<URI>);
const PluginContext = React.createContext({} as IPluginContext<URI>);

export const Layout = makeLayout(SlotContext);
export const Entry = makeEntry({
    SlotContext,
    EffectContext,
    ControllerContext,
    PluginContext,
    initSlots: {
        target: {
            component: IdentityComponent,
            props: {
                innerRef: () => React.useRef(null),
            }
        },
        text: {
            component: IdentityComponent,
            props: { children: () => null },
        },
    },
    initControllers: {},
    initEffect: [],
});
export const slotLayoutMaker = makeLayoutSlot(SlotContext);
